<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g>
    <rect width="32" height="32" fill="none"/>
    <g>
      <path class="filled" d="M16,3.243A12.757,12.757,0,1,0,28.757,16,12.756,12.756,0,0,0,16,3.243Zm-1.653,19.5L7.991,16.384l2.545-2.545,3.811,3.81,7.117-7.117,2.545,2.545Z" fill="#6bc153"/>
      <polygon class="cutout" points="14.347 17.649 10.536 13.839 7.991 16.384 14.347 22.741 24.009 13.077 21.464 10.532 14.347 17.649" fill="#fff"/>
    </g>
  </g>
</svg>
